<template>
  <div>
    <el-dialog
      class="course-schedule-chose-modal-contain clearfix"
      :visible.sync="dialogShow"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="true"
      :before-close="handleCloseModal"
      :width="'1200px'"
      :append-to-body="true"
      :title="$t('res.courseclassroomrela.alternativeCourse')"
    > 
      <p class="course-chose-title">{{ $t('courseSchedule.courseShowInfo') }}</p>
      <div class="course-chose-data">
        <div class="course-chose-lf">
          <article class="course-chose-filter clearfix">
            <div class="filter-module clearfix">
              <span class="filter-module-name">{{ $t('courseSchedule.courseAndPackage') }}</span>
              <span class="filter-module-value filter-module-value3">
                <el-input
                  v-model="searchData.courseNameCode"
                  @keyup.enter.native="searchDataList()"
                  :placeholder="$t('res.coursetrainerrela.courseNameCode')"
                ></el-input>
              </span>
            </div>
            <div class="filter-module clearfix">
              <span class="filter-module-name">{{ $t('courseSchedule.courseType') }}</span>
              <span class="filter-module-value">
                <el-select v-model="searchData.courseType" multiple clearable collapse-tags>
                  <el-option
                    v-for="item in courseTypeList"
                    :key="'courseType'+item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </span>
            </div>
            <div class="filter-module clearfix">
              <span class="filter-module-name">{{ $t('course.courseTeamCatalogId') }}</span>
              <span class="filter-module-value filter-module-value4">
                <el-select v-model="searchData.team" clearable @change="getSecondTeam($event)">
                  <el-option
                    v-for="item in teamList"
                    :key="'team'+item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </span>
              <span class="filter-module-value filter-module-value2">
                <el-select v-model="searchData.secondTeam" clearable>
                  <el-option
                    v-for="item in teamListTwo"
                    :key="'team2'+item.code"
                    :label="item.name"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </span>
            </div>
            <div class="filter-module filter-module2 clearfix">
              <el-button class="add-button" type="primary" @click="searchDataList">
                {{ $t("query") }}
              </el-button>
              <el-button class="add-button" type="info" @click="resetSearch">
                {{ $t("reset") }}
              </el-button>
            </div>
          </article>
          <article class="course-chose-list">
            <el-table border class="course-schedule-chose-table" ref="courseTable"
              :data="courseData" stripe @select="selectRedio" v-loading="loading">
              <el-table-column
                type="selection"
                header-align="center"
                align="center"
                :selectable="checkDisable"
                width="45">
              </el-table-column>
              <template v-for="(item,kindex) in courseColumn">
                <el-table-column :prop="item.prop"
                              :key="'courseChose'+item.prop"
                              show-overflow-tooltip
                              :width="item.width"
                              header-align="center"
                              align="center"
                              v-if="item.prop!=='courseDays'"
                              :formatter="item.formatter"
                              :label="item.label">
                </el-table-column>
                <el-table-column :prop="item.prop"
                              :key="'courseChose'+item.prop"
                              show-overflow-tooltip
                              :width="item.width"
                              header-align="center"
                              align="center"
                              v-else
                              :label="item.label">
                    <template slot-scope="scope">
                      <span>{{ scope.row[item.prop] }}</span>
                    </template>
                </el-table-column>
              </template>
            </el-table>
            <el-pagination
              :current-page="pageNum"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              :total="total"
              class="course-chose-pagination"
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="pageSizeChangeHandle"
              @current-change="pageCurrentChangeHandle"
            >
            </el-pagination>
          </article>
        </div>
        <div class="course-chose-lr">
          <article class="course-chose-save">
            <el-button class="add-button" type="primary" :disabled="!selection.courseCode" @click="choseCourse">
              {{ $t("confirm") }}
            </el-button>
          </article>
          <article class="course-chose-save-list">
            <p class="save-list-title">{{ $t('cert.selectedCourse') }}</p>
            <el-tag show-overflow-tooltip
              v-if="selection.courseCode"
              @close="handleCloseSelect()"
              closable>
              <span class="save-list-li-name">{{ selection.courseCode + '-' + selection.courseNameCn }}</span>
            </el-tag> 
          </article>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    courseTaskNew: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      pageSize: 10,
      pageNum: 1,
      total: 0,
      searchData: {
        courseNameCode: '',
        catalogId: '',
        team: '',
        secondTeam: '',
      },
      courseData: [],
      teamcatalogOne: this.enums['catalogidList1'],
      teamcatalogSecond: this.enums['catalogidList2'],
      allTeamCatalog: [],
      teamList: [],
      teamListTwo: [],
      teamPerms: 'TRAINERTEAM',
      loading: false,
      nameLoading: false,
      selection: {},
      courseColumn: [
        { prop: 'courseCode', label: this.$t('couse.coursecode') },
        { prop: 'courseNameCn', label: this.$t('couse.coursenamecn'), width: 130 },
        { prop: 'courseKindName', label: this.$t('courseSchedule.courseType') },
        { prop: 'courseTeamCatalogName', label: this.$t('couse.courseteamcatalogid'), width: 130 },
        { prop: 'courseCatalogName', label: this.$t('couse.coursecatalogid') },
        { prop: 'courseDays', label: this.$t('courseSchedule.courseDays'), width: 120 },
        { prop: 'coursePriority', label: this.$t('courseSchedule.courseTaskLevel'), width: 100 }
      ]
    };
  },
  computed: {
    courseTypeList() {
      const arr1 = this.enums['courseGroupType'].map((item) => {
        return { ...item, code: 'courseGroupType' + item.code };
      });
      const arr2 = this.enums['courseKind'].map((item) => {
        return { ...item, code: 'courseKind' + item.code };
      });
      return arr1.concat(arr2);
    }
  },
  methods: {
    checkPermission (val) {
      const dic = 'SC_TARGET_NEW:' + val;
      const dic2 = 'SC_TASK_NEW:' + val;
      if (JSON.parse(sessionStorage.getItem('v1user_data')).userCode === 'admin') {
        return true;
      }
      return this.courseTaskNew ? this.$hasPermission(dic2) : this.$hasPermission(dic);
    },
    checkDisable (row) {
      let checkFlg = false;
      if (this.checkPermission(row.courseTeamCatalogSecond)) {
        checkFlg = true;
      }
      return checkFlg;
    },
    getGroupListOne () {
      // 课程团队分类二级
      this.allTeamCatalog = this.teamcatalogSecond.filter((item) => {
        return this.$hasPermission(`${this.teamPerms}:${item.code}`);
      });
      if (this.allTeamCatalog.length === 0) {
        this.allTeamCatalog = this.teamcatalogSecond;
      }
      const arr = new Set();
      const data = [];
      const obj = {};
      const codes = this.teamcatalogOne.map((item) => item.code);
      this.teamcatalogOne.forEach((item) => {
        obj[item.code] = item;
      });
      // 课程团队分类一级
      this.allTeamCatalog.forEach(item => {
        const code = item.code.slice(0, 2);
        if (!arr.has(code)&&codes.includes(code)) {
          arr.add(code);
          data.push(obj[code]);
        }
      });
      this.teamList = [...arr].length === 0 ? this.teamcatalogOne : data;
    },
    getSecondTeam (e) {
      this.searchData.secondTeam = '';
      this.teamListTwo = this.allTeamCatalog.filter(item => {
        return e === item.code.slice(0, 2);
      });
    },
    resetSearch () {
      Object.keys(this.searchData).forEach((item) => {
        this.searchData[item] = '';
      });
      this.selection = {};
      this.pageSize = 10;
      this.pageNum = 1;
      this.getDataList();
    },
    handleCloseModal () {
      this.$emit('closeCourseChose', { courseInfo: {}, show: false });
    },
    getDataList () {
      const params = {
        page: this.pageNum,
        limit: this.pageSize,
        courseNameOrCode: this.searchData.courseNameCode,
        courseKind: this.searchData.courseType,
        courseTeamCatalogFirst: this.searchData.team,
        courseTeamCatalogSecond: this.searchData.secondTeam,
        filterType: 'SC_TARGET_NEW',
        courseToSplitMerge: true
      };
      this.loading = true;
      this.$request.get('/classschedule/courseInfo/getMixedCourse',params).then((res) => {
        if (res) {
          this.total = res.total;
          this.courseData = res.records.map((item) => {
            return { ...item, courseDays: item.courseDays ? item.courseDays.toFixed(2) : item.courseScheduledDays };
          });
          this.loading = false;
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    searchDataList () {
      this.pageSize = 10;
      this.pageNum = 1;
      this.getDataList();
    },
    selectRedio (_selection, row) {
      this.selection = {};
      if (this.$refs.courseTable.selection.length === 0) {
        this.selection = {};
        return false;
      }
      if (this.$refs.courseTable.selection.length > 1) {
        this.$refs.courseTable.clearSelection();
        this.$refs.courseTable.toggleRowSelection(row);
      }
      this.selection = row;
    },
    handleCloseSelect () {
      this.selection = {};
      this.$refs.courseTable.clearSelection();
    },
    pageSizeChangeHandle (val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.getDataList();
    },
    pageCurrentChangeHandle (val) {
      this.pageNum = val;
      this.getDataList();
    },
    choseCourse () {
      if (this.selection && this.selection.courseId) {
        this.$emit('closeCourseChose', { courseInfo: this.selection, show: false });
      }
    }
  },
  mounted() {
    this.selection = {};
    this.getGroupListOne();
    this.getDataList();
  },
};
</script>
<style lang="scss" scoped>
.course-schedule-chose-modal-contain {
  .course-chose-modal-title {
    width: 100%;
  }
  .course-chose-title {
    width: 100%;
    margin: 0 0 15px 0;
  }
  .course-chose-lf {
    border: 1px solid #EBEEF5;
    background-color: #FFF;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    padding: 20px;
    flex: 1;
    overflow: hidden;
  }
  .course-chose-lr{
    margin-left: 20px;
    width: 260px;
    .course-chose-save {
      background-color: #FFF;
      border: 1px solid #EBEEF5;
      border-radius: 4px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
      padding: 20px 10px;
      text-align: right;
      margin-bottom: 20px;
    }
    .course-chose-save-list {
      background-color: #FFF;
      border: 1px solid #EBEEF5;
      border-radius: 4px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
      padding: 10px;
      height: calc(100% - 96px);
      .save-list-title {
        text-align: center;
      }
      .save-list-li-name {
        width: 190px;
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .el-tag {
        width: 100% !important;
      }
    }
  }
  .course-chose-filter {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .filter-module {
      margin-right: 15px;
      line-height: 34px;
      &.filter-module2 {
        width: 160px;
        margin: 0;
        text-align: right;
        padding-top: 32px;
      }
      .filter-module-name {
        display: block;
        margin-right: 12px;
      }
      .filter-module-value {
        &.filter-module-value2 {
          width: 100px;
          float: left;
        }
        &.filter-module-value3 {
          width: 200px;
        }
        &.filter-module-value4 {
          width: 130px;
          float: left;
        }
      }
    }
  }
  .course-schedule-chose-table {
    margin-bottom: 10px;
  }
  .course-chose-pagination {
    text-align: right;
  }
}
</style>
<style lang="scss">
.course-schedule-chose-modal-contain{
  .el-dialog__body {
    padding-top: 0 !important;
  }
  .course-chose-data {
    display: flex !important;
  }
  .el-tag {
    .el-icon-close {
      top: -12px !important;
    }
  }
  .filter-module-value {
    .el-select__tags {
      max-width: 100% !important;
    }
  }
  .filter-module-value2 {
    .el-input__inner {
      border-left: none !important;
    }
  }
  .filter-module-value3 {
    .el-select {
      .el-input .el-input__inner{
        cursor: text !important;
      }
    }
  }
  .el-pagination__total {
    height: 32px !important;
    line-height: 32px !important;
  }
}
.course-schedule-chose-table {
  .el-table__header .el-checkbox {
    display: none !important;
  }
  .el-table__header {
    th {
      background-color: #ebecf0 !important;
      border-right: 1px #dcdee3 solid !important;
    }
  }
}
</style>